jQuery('document').ready(function ($) {
    //Initialisation
    var first_active;
    $('.filtered').each(function () {
        first_active = $('.filtered.active').data('filtered');
        if (!$(this).hasClass('active')) {
            $(this).css('display', 'none');
        }
    });
    $('.active_filter').each(function () {
        if ($(this).data('filter') == first_active) {
            //    $(this).css('background-color', '#FF4650');            
            $(this).css('opacity', 0.8);
        }
    });
    $('.active_filter').click(function (e) {
        var selectedFilter = $(this).data('filter');
        $('.active_filter').css('opacity', 1);
        // $('.active_filter').css('background-color', '#404040');
        if ($(this).hasClass('active_filter')) {
            $(this).css('opacity', .8);
            // $(this).css('background-color', '#FF4650');            
        }
        if ($(this).data('filter') != '') {
            $('.filtered').each(function () {
                var _this = this;
                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    $(this).fadeOut(300);
                }
                if ($(this).data('filtered') == selectedFilter) {
                    $(this).addClass('active');
                    setTimeout(function () {
                        $(_this).fadeIn();
                    }, 300);
                }
            });
        }
    });
});
